export enum FileRenderTypes {
  IMAGE = 1,
  DOCUMENT = 2,
  EMAIL = 3
}
